import { render, staticRenderFns } from "./including_balance.vue?vue&type=template&id=281e2da8&scoped=true&"
import script from "./including_balance.vue?vue&type=script&lang=js&"
export * from "./including_balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e2da8",
  null
  
)

export default component.exports